import React from 'react'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import 'react-confirm-alert/src/react-confirm-alert.css'
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import Api from '../../Api'
import DisplaySettings from '../Settings/DisplaySettings'
import ReactTooltip from 'react-tooltip'
import { GetLeaderboardPreference, UpdateLeaderboardPreference } from '../../actions/leaderboard'
import { arrayMove } from 'react-sortable-hoc'
import SortableBoard from './SortableBoard'
import CommonLoader from '../Alerts/CommonLoader'
import './SortableBoard.css'
import CommonService from '../Common/Functions'

class Leaderboard extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      isSavedPreferenceAvailable: false,
      headerTitleSecondTable: null,
      headerTitleThirdTable: null,
      isThirdTabeFilled: false,
      isValid: true,
      successMessage: '',
      saveSuccess: false,
      Showtables: ['Stores'],
      EmptyTableDropDown: [
        { name: 'Current Hour', visible: true, id: 't1' },
        { name: 'Previous Hour', visible: true, id: 't2' },
        { name: 'Current Day', visible: true, id: 't3' },
        { name: 'Previous Day', visible: true, id: 't4' },
        { name: 'Current Daypart', visible: true, id: 't5' },
        { name: 'Previous Daypart', visible: true, id: 't6' },
        { name: 'Current Rolling Hour', visible: true, id: 't7' },
        { name: 'Previous Rolling Hour', visible: true, id: 't8' }
      ],
      leaderboardData: {},
      firstTable: {
        id: 't0',
        disabled: true,
        header: 'Stores',
        columns: [
          {
            header: 'Rank',
            data: [1, 4, 8]
          },
          {
            header: 'Store',
            data: [44165, 55171, 66188]
          },
          {
            header: 'Goal',
            data: [210, 210, 210]
          }
        ]
      },
      showOverlay: {
        'opacity': '1',
        'display': 'none'
      },
      showAlert: false,
      tableData: [],
      renderEmptyContext: 2,
      showLoader: false,
      defaultsortmessage: false,
      preferenceValue: null
    }
    this.api = new Api()
    this.common = new CommonService()
    // this.convertReactToDBObject = this.convertReactToDBObject.bind(this)
    // this.convertDBObjectToReact = this.convertDBObjectToReact.bind(this)
    this.handleValidation = this.handleValidation.bind(this)
    this.handleSave = this.handleSave.bind(this)
    this.onAlertOkClick = this.onAlertOkClick.bind(this)
    this.resetDefault = this.resetDefault.bind(this)
    this.handleSortEndTable = this.handleSortEndTable.bind(this)
  }

  handleSortEndTable (sortorder) {
    let tableData = this.state.tableData
    tableData = arrayMove(tableData, sortorder.oldIndex, sortorder.newIndex)
    this.setState({ tableData: tableData })
  }

  resetDefault () {
    let tableData = []
    let data = {
      TimeFormat: 'mmss',
      PreferencePrimeColors: '#00b04c|#dcba00|#b40000',
      PreferenceDefaultView: 'Day',
      PreferenceDashPullins: '11',
      PreferenceStoreColumnName: 'Exclude',
      PreferenceDashMetric: '2000',
      PreferenceLanguage: 'en'
    }
    this.setState({ tableData })
    let leaderBoardPreference = this.common.convertReactToDBObject(this.state.firstTable, tableData)
    data.PreferenceDashObject = leaderBoardPreference.PreferenceDash
    data.PreferenceDash = JSON.stringify(leaderBoardPreference.PreferenceDash)
    data.PreferenceDashSort = leaderBoardPreference.PreferenceDashSort
    data.DashboardOrder = leaderBoardPreference.DashboardOrder
    data.LeaderboardModeID = this.state.preferenceValue.LeaderboardModeID
    this.handleSave(data, true)
  }

  handleSave (data, reset) {
    const language = this.state.language
    data.CompanyID = this.props.leaderBoardPreference.CompanyID
    data.CompanyUID = this.props.leaderBoardPreference.CompanyUID
    if (reset) {
      data.reset = true
      this.setState({ showLoader: true })
      this.props.UpdateLeaderboardPreference(data, result => {
        if (result.status) {
          this.setState({ saveSuccess: true, successMessage: t[language].leaderboardResetSuccess, showLoader: false })
        }
      })
    } else if (this.handleValidation()) {
      this.setState({ showLoader: true })
      let leaderBoardPreference = this.common.convertReactToDBObject(this.state.firstTable, this.state.tableData)
      data.PreferenceDashObject = leaderBoardPreference.PreferenceDash
      data.PreferenceDash = JSON.stringify(leaderBoardPreference.PreferenceDash)
      data.PreferenceDashSort = leaderBoardPreference.PreferenceDashSort
      data.DashboardOrder = leaderBoardPreference.DashboardOrder
      data.reset = false
      this.props.UpdateLeaderboardPreference(data, result => {
        if (result.status) {
          this.setState({ saveSuccess: true, successMessage: t[language].leaderboardCustomSuccess, showLoader: false })
        }
      })
    }
  }

  onAlertOkClick () {
    let defaultsortmessage = false
    let showAlert = false
    let showOverlay = {
      'opacity': '1',
      'display': 'none'
    }
    this.setState({ showAlert, showOverlay, defaultsortmessage })
  }

  handleValidation () {
    let isValid = true
    let showOverlay = this.state.showOverlay
    let showAlert = this.state.showAlert
    let defaultsortmessage = false
    if (this.state.tableData.length === 0) {
      isValid = false
      showAlert = true
      showOverlay = {
        'opacity': '1',
        'display': 'block'
      }
      defaultsortmessage = false
    } else {
      let preferenceValues = this.common.convertReactToDBObject(this.state.firstTable, this.state.tableData)
      if (preferenceValues.PreferenceDashSortObj.Sort === '') {
        isValid = false
        showAlert = true
        showOverlay = {
          'opacity': '1',
          'display': 'block'
        }
        defaultsortmessage = true
      }
    }
    this.setState({ isValid, showOverlay, showAlert, defaultsortmessage })

    return isValid
  }

  componentWillMount () {
    this.props.GetLeaderboardPreference()
    this.setState({ showLoader: true })
  }

  componentWillReceiveProps (newProp) {
    if (newProp.leaderBoardPreference.PreferenceDash) {
      const dbObject = JSON.parse(newProp.leaderBoardPreference.PreferenceDash)
      const PreferenceDashSort = newProp.leaderBoardPreference.PreferenceDashSort
      const preference = PreferenceDashSort.split('|')[0]
      const sort = PreferenceDashSort.split('|')[1]
      const preferenceSort = { preference, sort }
      const { EmptyTableDropDown, tableData, firstTable } = this.state
      const tables = this.common.convertDBObjectToReact(dbObject, preferenceSort, { EmptyTableDropDown, tableData, firstTable })
      this.setState({ firstTable: tables.firstTable, tableData: tables.tableData, EmptyTableDropDown: tables.EmptyTableDropDown })
    }
    if (newProp.leaderBoardPreference.CompanyUID) {
      this.setState({ showLoader: false, preferenceValue: newProp.leaderBoardPreference })
    }
  }

  render () {
    const showLoader = this.state.showLoader
    const { language } = this.state
    const customizeLeaderboardTips = () => {
      return (
        <p className='customeHeading'>
          <span translate key='createcustombyselecting'>{t[language].createcustombyselecting}</span><span className='blueText'>*</span> <span translate key='usingplussign'>{t[language].usingplussign}</span> <br /><br />
          <span translate key='toremovekpi'>{t[language].toremovekpi}</span><span className='blueText'>**</span> <span translate key='fromatimemeasurement'>{t[language].fromatimemeasurement}</span> <br /><br />
          <span translate key='addkpiuseplus'>{t[language].addkpiuseplus}</span> <br /><br />
          <span translate key='youmayselectdefault'>{t[language].youmayselectdefault}</span> <br /><br />
          <span translate key='torearrangetimemeasurement'>{t[language].torearrangetimemeasurement}</span> <br />
          <p className='whiteLine whiteLine_Pullin  customeHeading'>
            <span className='blueText'>* </span><span className='whiteText WhiteText_Bottom' translate key='validtimemeasure'>{t[language].validtimemeasure}</span><br /><br />
            <span className='blueText'>** </span><span className='whiteText' translate key='validkpicars'>{t[language].validkpicars}</span><br /><br />
            <span className='whiteText' translate key='carsaretotalnumber'>{t[language].carsaretotalnumber}</span>
          </p>
        </p>
      )
    }
    return (
      <section>
        <div className={showLoader ? 'hide' : this.state.saveSuccess ? 'show' : 'hide'}>
          <div className='forms clear'>
            <div className='appr' >
              <br />
              <br />
              <h4 translate='' key='recordsaved'>{this.state.successMessage}</h4>
              <br />
              <br />
            </div>
          </div>
        </div>
        <div className={showLoader ? 'show' : 'hide'}>
          <CommonLoader showLoader={showLoader} message={t[language].settingsStoresLoadingMessage1} language={language} />
        </div>
        <div id='leaderboard-container' className={'forms dash_cont relativecontainer ' + (this.state.saveSuccess || showLoader ? 'hide' : 'show')}>
          <div>
            <h3 className='dash_head'>
              <span>{t[language].leaderboardsettings}</span>
              <button type='button' id='ds_reset' onClick={this.resetDefault}>
                {t[language].resettodefaults}
              </button>
            </h3>
          </div>
          <div>
            <h5 className='customizeleaderboard'>
              <span>{t[language].customizeleaderboard}</span>
              <a data-tip data-for='customizeleadertip'><span className='tip openTip'>?</span> </a>
              <ReactTooltip id='customizeleadertip' place='right' type='dark' effect='solid' className='tooltip Arrow viewTipCont leadertips tooltips toolTip_darker customizeleaderboard'>
                {customizeLeaderboardTips()}
              </ReactTooltip>
            </h5>
          </div>
          <SortableBoard
            firstTable={this.state.firstTable}
            tableData={this.state.tableData}
            renderEmptyContext={this.state.renderEmptyContext}
            EmptyTableDropDown={this.state.EmptyTableDropDown}
            handleSortEndTable={this.handleSortEndTable} />
          {this.state.preferenceValue
            ? <DisplaySettings page='leaderboard' leaderBoardSaveHandle={this.handleSave}
              leaderboardData={this.state.preferenceValue} style={{ marginTop: '-55px' }} />
            : <div /> }
          <div className='sweet-overlay' tabindex='-1' style={this.state.showOverlay} />
          <SweetAlert show={this.state.showAlert} language={this.state.language} onOkClick={this.onAlertOkClick} sortmessage={this.state.defaultsortmessage} />
        </div>
      </section>
    )
  }
}

class SweetAlert extends React.Component {
  render () {
    return (
      <div className={'sweet-alert showSweetAlert visible ' + (this.props.show ? 'show' : 'hide')}
        data-custom-class='' data-has-cancel-button='false' data-has-confirm-button='true'
        data-allow-outside-click='false' data-has-done-function='false' data-animation='none' data-timer='null'
        style={{ 'display': 'block', 'marginTop': '-112px' }}><div className='sa-icon sa-error' style={{ 'display': 'none' }}>
          <span className='sa-x-mark'>
            <span className='sa-line sa-left' />
            <span className='sa-line sa-right' />
          </span>
        </div><div className='sa-icon sa-warning' style={{ 'display': 'none' }}>
          <span className='sa-body' />
          <span className='sa-dot' />
        </div><div className='sa-icon sa-info' style={{ 'display': 'none' }} />
        <div className='sa-icon sa-success' style={{ 'display': 'none' }}>
          <span className='sa-line sa-tip' />
          <span className='sa-line sa-long' />

          <div className='sa-placeholder' />
          <div className='sa-fix' />
        </div><div className='sa-icon sa-custom' style={{ 'display': 'none' }} /><h2>{t[this.props.language].error}</h2>
        <p className={this.props.sortmessage ? 'hide' : 'show'}>{t[this.props.language].selectatleastinecolumn}</p>
        <p className={this.props.sortmessage ? 'show' : 'hide'}>{t[this.props.language]['Please select the column of data']}</p>
        <p className={this.props.sortmessage ? 'show' : 'hide'}>{t[this.props.language]['rank your stores by']}</p>
        <fieldset>
          <input type='text' tabindex='3' placeholder='' />
          <div className='sa-input-error' />
        </fieldset><div className='sa-error-container'>
          <div className='icon'>!</div>
          <p>Not valid!</p>
        </div><div className='sa-button-container'>
          <button className='cancel' tabindex='2' style={{ 'display': 'none' }}>Cancel</button>
          <div className='sa-confirm-button-container'>
            <button className='confirm' tabindex='1' onClick={this.props.onOkClick}
              style={{
                'display': 'inline-block',
                'background-color': 'rgb(212, 27, 62)',
                'box-shadow': 'rgba(212, 27, 62, 0.8) 0px 0px 2px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px inset'
              }}>
              {t[this.props.language].OK}
            </button><div className='la-ball-fall' />
          </div>
        </div></div>
    )
  }
}

function mapStateToProps (state) {
  return {
    leaderBoardPreference: state.leaderboard.leaderBoardPreference
  }
}

function matchDispatchToProps (dispatch) {
  return bindActionCreators({
    GetLeaderboardPreference,
    UpdateLeaderboardPreference
  }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Leaderboard)



// WEBPACK FOOTER //
// ./src/components/LeaderBoard/Leaderboard.js